import { GdsServiceProductStatus, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { getActualProduct } from '../../../ServiceSummary/utils';
import { getTotalPrice } from '../../../utils';
export function mealOptionItemFactory({ key, serviceId, travellerId, direction, count, confirmedCount, gdsService, products, groupType = 'all' }) {
    var _a;
    let actualCount = count;
    let actualProducts = products.filter(product => product.passengerId === travellerId);
    const included = groupType === 'confirmed' || count === confirmedCount;
    const isAllSegments = key === 'allSegments';
    if (groupType === 'booked') {
        actualCount = count - confirmedCount;
        actualProducts = actualProducts.filter(product => product.status === GdsServiceProductStatus.Booked);
    }
    else if (groupType === 'confirmed') {
        actualCount = confirmedCount;
        actualProducts = actualProducts.filter(product => product.status === GdsServiceProductStatus.Ticketed);
    }
    return {
        name: `${direction}, ${actualCount}x ${gdsService.name}`,
        id: serviceId,
        segment: key,
        included,
        price: getTotalPrice(actualProducts, product => product.price),
        status: (_a = getActualProduct(actualProducts)) === null || _a === void 0 ? void 0 : _a.status,
        deleteMeta: !included
            ? {
                serviceId,
                passengerId: travellerId,
                segmentId: key,
                type: OrderAdditionalServiceGdsServiceServiceType.Meal,
                allSegments: isAllSegments
            }
            : null
    };
}
